/**
 * assets/v-glow-quiz.js
 * Colle ce fichier tel quel dans assets/. Aucun build requis.
 * Contient : data (tables du doc) + moteur de décision + logique UI du quiz.
 * Le catalogue produit (handles/variant IDs réels) est en bas — À REMPLIR.
 */
(function () {
  "use strict";

  /* ============================================================
   * 1) DATA — tables extraites du doc (sections 4-9)
   * ============================================================ */
  var BLOCK = { NO_CODE: "NO_CODE", DO_NOT_CODE: "DO_NOT_CODE", NO_EXACT_PRIMARY: "NO_EXACT_PRIMARY", OUT_OF_STOCK_KNOWN: "OUT_OF_STOCK_KNOWN" };

  var PRIMARY_SHADE_MAP = {
    "Porcelain Kween|Cool/Rosy|Light": { mousse: "N4", flawless: "N2", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Warm/Golden|Light": { mousse: "C2", flawless: "C3", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Neutral|Light": { mousse: "N4", flawless: "N3", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },
    "Porcelain Kween|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Fair" },

    "Sandy Muse|Cool/Rosy|Light": { mousse: "N4", flawless: "N5", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Warm/Golden|True": { mousse: "C4", flawless: "C4", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Neutral|True": { mousse: "N5", flawless: "N5", cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: BLOCK.OUT_OF_STOCK_KNOWN },
    "Sandy Muse|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Light" },

    "Golden Glow|Cool/Rosy|True": { mousse: "N7", flawless: "N8", cream: "N8", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Warm/Golden|True": { mousse: "C6", flawless: "C6", cream: "C7", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Neutral|True": { mousse: "N9", flawless: "N9", cream: "N8", hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },
    "Golden Glow|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Light Medium" },

    "Caramel Queen|Cool/Rosy|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N10", cream: "N10", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Warm/Golden|True": { mousse: "C8", flawless: "C8", cream: "C8", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Neutral|True": { mousse: "C8", flawless: "N10", cream: "N10", hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },
    "Caramel Queen|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Medium" },

    "Deep Ebony|Cool/Rosy|True": { mousse: "N25", flawless: "N25", cream: "N14", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Warm/Golden|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "C10", cream: "C10", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Neutral|True": { mousse: "N25", flawless: "N25", cream: "N15", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Deep Ebony|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },

    "Rich Royalty|Cool/Rosy|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N45", cream: "N95", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Warm/Golden|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: BLOCK.NO_EXACT_PRIMARY, cream: BLOCK.NO_EXACT_PRIMARY, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Neutral|True": { mousse: BLOCK.NO_EXACT_PRIMARY, flawless: "N45", cream: "N95", hidef: BLOCK.DO_NOT_CODE, bb: "Dark" },
    "Rich Royalty|Olive|any": { mousse: BLOCK.NO_CODE, flawless: BLOCK.NO_CODE, cream: BLOCK.NO_CODE, hidef: BLOCK.DO_NOT_CODE, bb: "Dark" }
  };

  function chooseFormula(a) {
    if (a.coverage === "Light") return "bb";
    if (a.coverage === "Full" && a.skinType === "Dry") return "cream";
    if (a.skinType === "Oily" && a.finish === "Matte") return "mousse";
    if (a.coverage === "Medium") return "flawless";
    if (a.skinType === "Combination") return a.finish === "Matte" ? "mousse" : "flawless";
    return "flawless";
  }

  var CORRECTOR_MAP = {
    "Porcelain Kween": { "Dark circles": "Rose corrector", "Purple/blue circles": "Rose corrector", "Uneven skin tone": "Corrector Palette — Light" },
    "Sandy Muse": { "Dark circles": "Peachy corrector", "Purple/blue circles": "Peachy corrector", "Uneven skin tone": "Corrector Palette — Medium" },
    "Golden Glow": { "Dark circles": "Peach corrector", "Purple/blue circles": "Peach corrector", "Uneven skin tone": "Corrector Palette — Medium" },
    "Caramel Queen": { "Dark circles": "Mandarine corrector", "Purple/blue circles": "Mandarine corrector", "Uneven skin tone": "Corrector Palette — Medium Deep" },
    "Deep Ebony": { "Dark circles": "Profound Peachy corrector", "Purple/blue circles": "Profound Peachy corrector", "Uneven skin tone": "Corrector Palette — Deep" },
    "Rich Royalty": { "Dark circles": "Profound Peachy corrector", "Purple/blue circles": "Profound Peachy corrector", "Uneven skin tone": "Corrector Palette — Deep" }
  };
  var CORRECTOR_SKIP_CONCERNS = ["Shine/oil control", "Dull complexion"];

  /*var CONCEALER_MAP = {
    "Porcelain Kween": { product: "Liquid Concealer", shade: "Fair/C2" },
    "Sandy Muse": { product: "Liquid Concealer", shade: "Light/N5" },
    "Golden Glow": { product: "Liquid Concealer", shade: "Medium/N8" },
    "Caramel Queen": { product: "Liquid Concealer", shade: "Medium Deep/N10" },
    "Deep Ebony": { product: "Liquid Concealer", shade: "Deep/N25" },
    "Rich Royalty": { product: "Liquid Concealer", shade: "Rich/N45" }
  };*/

  var CONCEALER_MAP = {
  "Porcelain Kween": { product: "Cream Concealer", shade: "C3" },
  "Sandy Muse": { product: "Cream Concealer", shade: "C5" },
  "Golden Glow": { product: "Cream Concealer", shade: "C7" },
  "Caramel Queen": { product: "Cream Concealer", shade: "C10" },
  "Deep Ebony": { product: "Cream Concealer", shade: "C25" },
  "Rich Royalty": { product: "Cream Concealer", shade: "C85" }
};

  var BLUSH_MAP = {
    "Porcelain Kween": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Cherry Blossom", "Boss Energy": "Cherry Blossom", "Full Glam": "Cherry Blossom" },
    "Sandy Muse": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Magnolia", "Boss Energy": "Magnolia", "Full Glam": "Magnolia" },
    "Golden Glow": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Abricot", "Boss Energy": "Abricot", "Full Glam": "Abricot" },
    "Caramel Queen": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Rose Gold", "Boss Energy": "Rose Gold", "Full Glam": "Rose Gold" },
    "Deep Ebony": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Bonbon", "Boss Energy": "Bonbon", "Full Glam": "Bonbon" },
    "Rich Royalty": { "Natural Everyday": "Natural Kiss", "Soft Glam": "Deep Skin", "Boss Energy": "Deep Skin", "Full Glam": "Deep Skin" }
  };

  var GLOW_MAP = {
    "Porcelain Kween": { "Natural Everyday": "Sheer Glo Flash", "Soft Glam": "Strobing Barbapapa", "Boss Energy": "Strobing Barbapapa", "Full Glam": "Strobing Barbapapa" },
    "Sandy Muse": { "Natural Everyday": "Sheer Glo Flash", "Soft Glam": "Sheer Glo Sweet Dream", "Boss Energy": "Strobing Beautiful Montreal", "Full Glam": "Strobing Beautiful Montreal" },
    "Golden Glow": { "Natural Everyday": "Sheer Glo Sweet Dream", "Soft Glam": "Strobing Super Star", "Boss Energy": "Summer Glow palette", "Full Glam": "Summer Glow palette" },
    "Caramel Queen": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Sunset Beach", "Boss Energy": "Summer Glow palette", "Full Glam": "Summer Glow palette" },
    "Deep Ebony": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Autumn", "Boss Energy": "Deep and Delicious palette", "Full Glam": "Deep and Delicious palette" },
    "Rich Royalty": { "Natural Everyday": "Sheer Glo Nice Peach", "Soft Glam": "Strobing Autumn", "Boss Energy": "Deep and Delicious palette", "Full Glam": "Deep and Delicious palette" }
  };

  var LIP_MAP = {
    "Porcelain Kween": { "Boss Matte™": "Liquid Velvet Slay", "Glossy Muse™": "Lip Gloss Nev-Rosé", "Nude Everyday": "Velvet Pink Light", "Bold Statement": "Vinyl Lacquer Unity", "Surprise Me": "Vinyl Lacquer Laughter" },
    "Sandy Muse": { "Boss Matte™": "Velvet Bubbly", "Glossy Muse™": "Lip Gloss Awake", "Nude Everyday": "Velvet Skin", "Bold Statement": "Vinyl Lacquer Sacha", "Surprise Me": "Vinyl Lacquer Kind" },
    "Golden Glow": { "Boss Matte™": "Velvet Smile", "Glossy Muse™": "Lip Gloss Ékla", "Nude Everyday": "Velvet Pozé", "Bold Statement": "Velvet Hope", "Surprise Me": "Vinyl Lacquer Compassionate" },
    "Caramel Queen": { "Boss Matte™": "Velvet Attitude", "Glossy Muse™": "Lip Gloss Narcist", "Nude Everyday": "Velvet Faith", "Bold Statement": "Velvet Kandy", "Surprise Me": "Vinyl Lacquer Josefine" },
    "Deep Ebony": { "Boss Matte™": "Velvet Scream", "Glossy Muse™": "Lip Gloss Dark Mind", "Nude Everyday": "Velvet Deep Desire", "Bold Statement": "Velvet Scarlett", "Surprise Me": "Vinyl Lacquer Hot Passion" },
    "Rich Royalty": { "Boss Matte™": "Velvet Night Out", "Glossy Muse™": "Lip Gloss Crisis", "Nude Everyday": "Velvet Money Shot", "Bold Statement": "Velvet Thunderstorm", "Surprise Me": "Vinyl Lacquer Confident" }
  };

  var COPY = {
    helpStates: {
      shadeHelp: "Need help confirming my shade",
      mappingPending: "complementary recommendation — mapping pending",
      productUnavailable: "product unavailable — choose another routine level"
    },
    routineCTA: "GET MY V-GLOW ROUTINE"
  };

  /* ============================================================
   * 2) CATALOGUE — ⚠️ À REMPLIR avec tes vrais handles/variant IDs
   *    Trouve un variant ID: Admin → Produit → variante → URL,
   *    ou fetch('/products/HANDLE.js') puis regarde variants[].id
   * ============================================================ */
var CATALOG = {
  foundation: {
    "Mousse Foundation": { handle: "mousse-foundation" },
    "Flawless Foundation": { handle: "hi-def-foundation" }, // "Dewy Finish Hi-Def Foundation"
    "Cream Foundation": { handle: "cream-foundation" },
    "BB Cream": { handle: "bb-cream" }
  },
  corrector: { "Under-Eye Corrector": { handle: "under-eye-corrector" } },
 // concealer: { "Liquid Concealer": { handle: "concealer-pot" } }, // 
 concealer: { "Cream Concealer": { handle: "concealer-pot" } },
  
  blush: {
  "Natural Kiss": { handle: "blush-c" },
  "Cherry Blossom": { handle: "blush-b" },
  "Magnolia": { handle: "blush-a" },
  "Abricot": { handle: "blush-g" },
  "Rose Gold": { handle: "blush-f" },
  "Bonbon": { handle: "blush-d" },
  "Deep Skin": { handle: "blush-e" }
},
  /*blush: {
    "Natural Kiss": { handle: "blush-c" },
    "Cherry Blossom": { handle: "blush-b" },
    "Magnolia": { handle: "blush-a" },
    "Abricot": { handle: "blush-g" },
    "Rose Gold": { handle: "blush-f" },
    "Bonbon": { handle: "blush-d" },
    "Deep Skin": { handle: "blush-e" }
  },*/
 glow: {
  "Sheer Glo Flash": { handle: "sheer-glow-illuminating-lotion", key: "Flash" },
  "Sheer Glo Sweet Dream": { handle: "sheer-glow-illuminating-lotion", key: "Sweet Dream" },
  "Sheer Glo Nice Peach": { handle: "sheer-glow-illuminating-lotion", key: "Nice Peach" },
  "Strobing Barbapapa": { handle: "spot-light-strobing-d" },
  "Strobing Beautiful Montreal": { handle: "spot-light-strobing-b" },
  "Strobing Super Star": { handle: "spot-light-strobing-c" },
  "Strobing Sunset Beach": { handle: "spot-light-strobing-a" },
  "Strobing Autumn": { handle: "spot-light-strobing-e" },
  "Summer Glow palette": { handle: "eyeshadow-blush-palette-d" },
  "Deep and Delicious palette": { handle: "eyeshadow-blush-palette" }
},
  lip: {
    // ⚠️ voir note plus bas, à mapper produit par produit
  }
};

  /* ============================================================
   * 3) MOTEUR — vérif stock + résolution par catégorie
   * ============================================================ */
  function isBlocked(v) {
    return v === BLOCK.NO_CODE || v === BLOCK.DO_NOT_CODE || v === BLOCK.NO_EXACT_PRIMARY || v === BLOCK.OUT_OF_STOCK_KNOWN;
  }

  function help(kind, category) {
    return { category: category, product: null, shade: null, variant: null, variantId: null, reason: null, helpState: kind };
  }

  /* function verifyVariant(entry, key) {
    if (!entry || !entry.variantMap || !entry.variantMap[key]) {
      return Promise.resolve({ ok: false });
    }
    var variantId = entry.variantMap[key];
    return fetch("/products/" + entry.handle + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product) return { ok: false };
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === variantId) variant = product.variants[i];
        }
        if (!variant || !variant.available) return { ok: false };
        return { ok: true, variant: variant };
      })
      .catch(function () { return { ok: false }; });
  }*/
function verifyVariant(entry, key) {
  if (!entry || !entry.handle || !key) return Promise.resolve({ ok: false });
  return fetch("/products/" + entry.handle + ".js")
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (product) {
      if (!product) return { ok: false };
      var needle = key.toLowerCase();
      var variant = product.variants.find(function (v) {
        return v.title.toLowerCase().indexOf(needle) !== -1 && v.available;
      });
      if (!variant) return { ok: false };
      return { ok: true, variant: variant, product: product };
    })
    .catch(function () { return { ok: false }; });
}


  function resolveFoundation(a) {
    if (a.undertone === "Olive") return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var row = PRIMARY_SHADE_MAP[a.vFamily + "|" + a.undertone + "|" + a.subDepth] || PRIMARY_SHADE_MAP[a.vFamily + "|" + a.undertone + "|True"];
    if (!row) return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var formulaKey = chooseFormula(a);
    var candidate = row[formulaKey];
    if (isBlocked(candidate)) return Promise.resolve(help(COPY.helpStates.shadeHelp, "foundation"));
    var names = { mousse: "Mousse Foundation", flawless: "Flawless Foundation", cream: "Cream Foundation", bb: "BB Cream" };
    var productName = names[formulaKey];
    return verifyVariant(CATALOG.foundation[productName], candidate).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.productUnavailable, "foundation");
      return {
        category: "foundation", product: productName, shade: candidate, variantId: check.variant.id,
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your " + a.vFamily + " complexion, " + a.undertone.toLowerCase() + " undertone, " + a.skinType.toLowerCase() + " skin and " + a.coverage.toLowerCase() + " coverage preference make this your strongest V-Match.",
        helpState: null
      };
    });
  }




  function resolveCorrector(a) {
    if (CORRECTOR_SKIP_CONCERNS.indexOf(a.beautyConcern) !== -1) {
      return Promise.resolve({ category: "corrector", product: null, helpState: null, skipped: true });
    }
    var row = CORRECTOR_MAP[a.vFamily];
    var variantName = row && row[a.beautyConcern];
    if (!variantName) return Promise.resolve(help(COPY.helpStates.mappingPending, "corrector"));
    return verifyVariant(CATALOG.corrector["Under-Eye Corrector"], variantName).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "corrector");
      return { 
          category: "corrector", product: "Under-Eye Corrector", shade: variantName, variantId: check.variant.id, 
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your selected concern and " + a.vFamily + " family make this the mapped primary corrector.", helpState: null };
    });
  }

  function resolveConcealer(a) {
    var entry = CONCEALER_MAP[a.vFamily];
    if (!entry) return Promise.resolve(help(COPY.helpStates.mappingPending, "concealer"));
    return verifyVariant(CATALOG.concealer[entry.product], entry.shade).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "concealer");
      return { category: "concealer", product: entry.product, shade: entry.shade, variantId: check.variant.id, 
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "This is the mapped same-skin complexion match for your family.", helpState: null };
    });
  }

  function resolveBlush(a) {
    var product = BLUSH_MAP[a.vFamily] && BLUSH_MAP[a.vFamily][a.beautyStyle];
    if (!product) return Promise.resolve(help(COPY.helpStates.mappingPending, "blush"));
    return verifyVariant(CATALOG.blush[product], "default").then(function (check) {
      if (!check.ok) return help(COPY.helpStates.mappingPending, "blush");
      return { category: "blush", product: product, variantId: check.variant.id,
         image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
        reason: "Your " + a.vFamily + " family and " + a.beautyStyle + " style map to this primary blush.", helpState: null };
    });
  }

 function resolveGlow(a) {
  var product = GLOW_MAP[a.vFamily] && GLOW_MAP[a.vFamily][a.beautyStyle];
  var entry = product && CATALOG.glow[product];
  if (!entry) return Promise.resolve(help(COPY.helpStates.mappingPending, "glow"));
  return verifyVariant(entry, entry.key || "default").then(function (check) {
    if (!check.ok) return help(COPY.helpStates.mappingPending, "glow");
    return {
      category: "glow", product: check.product.title, variantId: check.variant.id,
      image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
      reason: "Your family and " + a.beautyStyle + " style map to the strongest listed glow primary.",
      helpState: null
    };
  });
}

  var LIP_CATALOG = {
  "Velvet": { handle: "creamy-liquid-lipstick" },
  "Lip Gloss": { handle: "long-lasting-lipgloss" },
  "Vinyl Lacquer": { handle: "intense-lacquer" }
};

function resolveLip(a) {
  var shadeFull = LIP_MAP[a.vFamily] && LIP_MAP[a.vFamily][a.lipPreference];
  if (!shadeFull) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));

  var prefix = Object.keys(LIP_CATALOG).find(function (p) { return shadeFull.indexOf(p) === 0; });
  if (!prefix) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));

  var shadeName = shadeFull.replace(prefix, "").trim(); // ex: "Velvet Slay" -> "Slay"
  return verifyVariant(LIP_CATALOG[prefix], shadeName).then(function (check) {
    if (!check.ok) return help(COPY.helpStates.productUnavailable, "lip");
    return {
      category: "lip", product: check.product.title, shade: shadeName,
      variantId: check.variant.id,
      image: (check.variant.featured_image && check.variant.featured_image.src) || check.product.featured_image,
      reason: "Your " + a.lipPreference + " preference and " + a.vFamily + " family map to this primary lip.",
      helpState: null
    };
  });
}
  /*function resolveLip(a) {
    var shade = LIP_MAP[a.vFamily] && LIP_MAP[a.vFamily][a.lipPreference];
    if (!shade) return Promise.resolve(help(COPY.helpStates.productUnavailable, "lip"));
    return verifyVariant(CATALOG.lip["Lip Product"], shade).then(function (check) {
      if (!check.ok) return help(COPY.helpStates.productUnavailable, "lip");
      return { category: "lip", product: "Lip Product", shade: shade, variantId: check.variant.id, reason: "Your " + a.lipPreference + " preference and " + a.vFamily + " family map to this primary lip.", helpState: null };
    });
  }*/

  function resolveKit(a, r) {
    var allActive = Object.keys(r).every(function (k) { return r[k].helpState === null || r[k].skipped; });
    if (!allActive) return "Essential";
    if (a.beautyStyle === "Full Glam" || a.coverage === "Full") return "Ultimate V-Glow";
    return "Power Glow";
  }

  function computeVGlowResult(answers) {
    return Promise.all([
      resolveFoundation(answers), resolveCorrector(answers), resolveConcealer(answers),
      resolveBlush(answers), resolveGlow(answers), resolveLip(answers)
    ]).then(function (arr) {
      var r = { foundation: arr[0], corrector: arr[1], concealer: arr[2], blush: arr[3], glow: arr[4], lip: arr[5] };
      return {
        profile: answers.vFamily,
        beautyDNA: {
          skinTone: answers.vFamily, undertone: answers.undertone, oliveRefinement: answers.oliveRefinement || null,
          skinType: answers.skinType, coverage: answers.coverage, beautyConcern: answers.beautyConcern,
          beautyStyle: answers.beautyStyle, lipPreference: answers.lipPreference
        },
        foundationMatch: r.foundation, correctorMatch: r.corrector, concealerMatch: r.concealer,
        blushMatch: r.blush, glowMatch: r.glow, lipMatch: r.lip,
        kit: resolveKit(answers, r),
        stockStatus: Object.keys(r).every(function (k) { return r[k].helpState === null; }) ? "all mapped variants available" : "partial"
      };
    });
  }

  /* ============================================================
   * 4) UI — state machine du quiz (7 écrans + micro-question Olive)
   * ============================================================ */
  var QUESTIONS = [
    {
  key: "vFamily",
  title: "WHICH FAMILY FEELS CLOSEST TO YOU?",
  options: [
    {
      title: "Porcelain Kween",
      description: "Very fair skin, often with freckles or pink undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-1.webp?v=1782736268&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Sandy Muse",
      description: " Light to medium skin, sand/neutral beige complexion ",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-2.webp?v=1782736299&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Golden Glow",
      description: "Olive or golden skin, bronze easily",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-3.webp?v=1782736320&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Caramel Queen",
      description: "Caramel skin, light black, mixed or Indian skin, warm undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-4.webp?v=1782736341&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Deep Ebony",
      description: "Dark, rich, chocolate skin, caramel, light black, mixed or Indian skin, warm undertones   ",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-5.webp?v=1782736372&width=352.00000524520874&height=352.00000524520874"
    },
    {
      title: "Rich Royalty",
      description: " Very deep skin, pure ebony with cold or neutral undertones",
      image: "https://cdn.shopify.com/s/files/1/0014/9749/7675/files/quiz-THE_V_QUIZ_GLOW_f-6.webp?v=1782736395&width=352.00000524520874&height=352.00000524520874"
    }
  ]
},
    //{ key: "vFamily", title: "WHICH FAMILY FEELS CLOSEST TO YOU?", options: ["Porcelain Kween", "Sandy Muse", "Golden Glow", "Caramel Queen", "Deep Ebony", "Rich Royalty"] },
    { key: "undertone", title: "WHAT'S YOUR UNDERTONE?", options: ["Cool/Rosy", "Warm/Golden", "Neutral", "Olive", "I'm Not Sure"] },
    { key: "subDepth", title: "HOW DEEP IS YOUR SHADE?", options: ["Light", "True", "Deeper"] },
    { key: "skinType", title: "WHAT'S YOUR SKIN TYPE?", options: ["Dry", "Oily", "Combination", "Normal"] },
    { key: "coverage", title: "HOW MUCH COVERAGE DO YOU WANT?", options: ["Light", "Medium", "Full"] },
    { key: "finish", title: "WHAT FINISH DO YOU PREFER?", options: ["Natural", "Radiant", "Satin", "Soft Matte", "Matte"] },
    { key: "beautyConcern", title: "WHAT'S YOUR MAIN BEAUTY CONCERN?", options: ["Dark circles", "Dull complexion", "Imperfections", "Uneven skin tone", "Shine/oil control", "Full glow-up"] },
    { key: "beautyStyle", title: "WHAT'S YOUR BEAUTY STYLE?", options: ["Natural Everyday", "Soft Glam", "Boss Energy", "Full Glam", "NOT SURE — GUIDE ME"] },
    { key: "lipPreference", title: "WHAT'S YOUR LIP PREFERENCE?", options: ["Boss Matte™", "Glossy Muse™", "Nude Everyday", "Bold Statement", "Surprise Me"] }
  ];
  var OLIVE_QUESTION = {
    key: "oliveRefinement",
    title: "LET'S REFINE YOUR OLIVE UNDERTONE",
    sub: "Which description feels closest to your skin?",
    options: [
      { value: "GOLDEN OLIVE", label: "GOLDEN OLIVE — My skin has an olive cast with noticeable golden warmth." },
      { value: "NEUTRAL OLIVE", label: "NEUTRAL OLIVE — My skin looks more muted/neutral than golden or rosy." },
      { value: "I'M NOT SURE", label: "I'M NOT SURE — Help me choose." }
    ]
  };

  function initVGlowQuiz(root) {
    var answers = {};
    var flow = QUESTIONS.slice();
    var stepIndex = 0;

    function currentFlow() {
      // insère la micro-question Olive juste après "undertone" si besoin
      var f = QUESTIONS.slice();
      if (answers.undertone === "Olive") {
        var idx = f.findIndex(function (q) { return q.key === "undertone"; });
        f.splice(idx + 1, 0, OLIVE_QUESTION);
      }
      return f;
    }

function renderQuestion() {
  var f = currentFlow();
  var q = f[stepIndex];

  if (!q) {
    renderEmailGate();
    return;
  }

  var total = f.length;

  var optsHtml = (q.options || []).map(function (opt) {
    var isObject = typeof opt === "object";

    var value = isObject ? (opt.value || opt.title) : opt;
    var label = isObject ? (opt.label || opt.title) : opt;
    var description = isObject ? (opt.description || "") : "";
    var image = isObject ? (opt.image || "") : "";

    var isSelected = answers[q.key] === value;

    return (
      '<button class="vglow-option' +
      (isSelected ? " vglow-option-selected" : "") +
      '" data-value="' +
      value.replace(/"/g, "&quot;") +
      '">' +

      (image
        ? '<img class="vglow-option-image" src="' +
          image +
          '" alt="' +
          label.replace(/"/g, "&quot;") +
          '" loading="lazy">'
        : "") +

      '<span class="vglow-option-content">' +
        '<span class="vglow-option-title">' +
          label +
        '</span>' +

        (description
          ? '<span class="vglow-option-description">' +
              description +
            '</span>'
          : "") +

      '</span>' +

      "</button>"
    );
  }).join("");

  var backBtnHtml = stepIndex > 0
    ? '<button class="vglow-back" id="vglow-back-btn">← Back</button>'
    : "";

  root.innerHTML =
    '<div class="vglow-progress">Question ' +
      (stepIndex + 1) +
      " of " +
      total +
    "</div>" +

    '<p class="vglow-microcopy">' +
      (stepIndex < total - 1
        ? "You're getting closer to your V-Glow."
        : "Almost there…") +
    "</p>" +

    '<h2 class="vglow-title">' +
      q.title +
    "</h2>" +

    (q.sub
      ? '<p class="vglow-sub">' + q.sub + "</p>"
      : "") +

    '<div class="vglow-options">' +
      optsHtml +
    "</div>" +

    backBtnHtml;
  
  root.querySelectorAll(".vglow-option").forEach(function (btn) {
    btn.addEventListener("click", function () {
      answers[q.key] = btn.getAttribute("data-value");
      stepIndex++;
      renderQuestion();
    });
  });

  if (stepIndex > 0) {
    root.querySelector("#vglow-back-btn").addEventListener("click", function () {
      stepIndex--;
      renderQuestion();
    });
  }

  
}

function renderEmailGate() {
  root.innerHTML =
    '<h2 class="vglow-title">YOUR V-GLOW IS READY ✨</h2>' +
    '<p class="vglow-sub">We\'ve analyzed your complexion, undertone, skin needs and beauty style. Enter your email to reveal your personalized V-Glow Profile™ + complete beauty routine.</p>' +
    '<form class="vglow-email-form"><input type="email" name="email" required placeholder="you@email.com" class="vglow-input" />' +
    '<button type="submit" class="vglow-cta">REVEAL MY V-GLOW →</button></form>' +
    '<button class="vglow-back" id="vglow-back-btn">← Back</button>';

  root.querySelector(".vglow-email-form").addEventListener("submit", function (e) {
    e.preventDefault();
    answers.email = e.target.email.value;
    submitEmailToShopify(answers.email, answers.vFamily);
    renderTransition();
  });

  root.querySelector("#vglow-back-btn").addEventListener("click", function () {
    stepIndex = currentFlow().length - 1;
    renderQuestion();
  });
}
function submitEmailToShopify(email, vFamily) {
  var form = document.createElement("form");
  form.method = "POST";
  form.action = "/contact#contact_form";
  form.style.display = "none";
  form.target = "vglow-hidden-iframe";

  function addField(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  addField("form_type", "customer");
  addField("utf8", "✓");
  addField("contact[email]", email);
  // ⚠️ Champ indispensable : sans lui, Shopify crée bien le client mais
  // ne l'inscrit PAS au marketing/newsletter, donc il n'apparaît pas
  // dans ta liste d'abonnés (c'était le bug).
  addField("contact[accepts_marketing]", "1");
  addField("contact[tags]", "v-glow-quiz" + (vFamily ? "," + vFamily : ""));

  var iframe = document.createElement("iframe");
  iframe.name = "vglow-hidden-iframe";
  iframe.style.display = "none";
  document.body.appendChild(iframe);
  document.body.appendChild(form);
  form.submit();

  setTimeout(function () {
    form.remove();
    iframe.remove();
  }, 3000);
}

    function renderTransition() {
      root.innerHTML =
        '<h2 class="vglow-title">CREATING YOUR V-GLOW…</h2>' +
        '<ul class="vglow-checklist">' +
        '<li>✓ Matching your complexion</li><li>✓ Reading your undertone</li>' +
        '<li>✓ Personalizing your beauty goals</li><li>✓ Building your V Kosmetik routine</li>' +
        "</ul>";
      computeVGlowResult(answers).then(function (result) {
        setTimeout(function () { renderResult(result); }, 900); // court délai cosmétique pour laisser voir la checklist
      });
    }

      function line(match) {
  if (!match || match.skipped) return "";
  if (match.helpState) return '<div class="vglow-result-line vglow-help">' + match.helpState + "</div>";
  //var shadeTxt = match.shade ? " — " + match.shade : match.variant ? " — " + match.variant.title : "";
  var shadeTxt = match.shade ? " — " + match.shade : "";
  var imgHtml = match.image
    ? '<img class="vglow-product-img" src="' + match.image + '" alt="' + match.product + '" width="80" height="80" loading="lazy">'
    : "";
  return (
    '<div class="vglow-result-line">' +
    imgHtml +
    '<div class="vglow-result-info">' +
    "<strong>" + match.product + shadeTxt + "</strong>" +
    '<p class="vglow-reason">' + (match.reason || "") + "</p>" +
    '<button class="vglow-add-single" data-variant-id="' + match.variantId + '">Add to cart</button>' +
    "</div>" +
    "</div>"
  );
}

    /* ------------------------------------------------------------
     * Compte à rebours de l'offre — persiste par session (sessionStorage)
     * pour rester cohérent tant que la personne navigue, mais repart
     * à zéro à sa prochaine visite/session.
     * ------------------------------------------------------------ */
    var COUNTDOWN_MINUTES = 15; // ⚠️ ajustable : durée de l'urgence affichée
    var countdownInterval = null;

    function getCountdownEndTime() {
      var stored = null;
      try { stored = sessionStorage.getItem("vglowCountdownEnd"); } catch (e) {}
      var end = stored ? parseInt(stored, 10) : 0;
      if (!end || end < Date.now()) {
        end = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
        try { sessionStorage.setItem("vglowCountdownEnd", String(end)); } catch (e) {}
      }
      return end;
    }

    function startCountdown() {
      var endTime = getCountdownEndTime();
      var elH = document.getElementById("vglow-cd-h");
      var elM = document.getElementById("vglow-cd-m");
      var elS = document.getElementById("vglow-cd-s");
      if (!elH || !elM || !elS) return;

      function pad(n) { return String(n).padStart(2, "0"); }

      function tick() {
        var remaining = endTime - Date.now();
        if (remaining <= 0) {
          // L'offre "repart" pour garder l'urgence active sans afficher 00:00:00
          endTime = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
          try { sessionStorage.setItem("vglowCountdownEnd", String(endTime)); } catch (e) {}
          remaining = endTime - Date.now();
        }
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        elH.textContent = pad(h);
        elM.textContent = pad(m);
        elS.textContent = pad(s);
      }

      tick();
      if (countdownInterval) clearInterval(countdownInterval);
      countdownInterval = setInterval(tick, 1000);
    }

    function renderResult(result) {
      var addableIds = [result.foundationMatch, result.correctorMatch, result.concealerMatch, result.blushMatch, result.glowMatch, result.lipMatch]
        .filter(function (m) { return m && m.helpState === null && m.variantId; })
        .map(function (m) { return { id: m.variantId, quantity: 1 }; });

      root.innerHTML =
        '<h2 class="vglow-title">YOUR V-GLOW PROFILE™</h2>' +
        '<h3 class="vglow-family">YOU ARE THE ' + result.profile.toUpperCase() + '™</h3>' +
        '<h4>YOUR #1 FOUNDATION MATCH</h4>' + line(result.foundationMatch) +
        '<h4>UNDER-EYE CORRECTOR</h4>' + line(result.correctorMatch) +
        '<h4>CONCEALER</h4>' + line(result.concealerMatch) +
        '<h4>BLUSH</h4>' + line(result.blushMatch) +
        '<h4>GLOW / HIGHLIGHT</h4>' + line(result.glowMatch) +
        '<h4>LIP PRODUCT</h4>' + line(result.lipMatch) +
        '<p class="vglow-kit">Recommended kit: <strong>' + result.kit + "</strong></p>" +
        '<div class="vglow-offer-card">' +
          '<p class="vglow-offer-label">✦ Personalized Offer ✦</p>' +
          '<h3 class="vglow-offer-headline">Your ideal routine awaits you</h3>' +
          '<p class="vglow-offer-urgency"> - Your selection expires soon - </p>' +
          '<div class="vglow-countdown">' +
            '<div class="vglow-countdown-block"><span class="vglow-countdown-num" id="vglow-cd-h">00</span><span class="vglow-countdown-label">Heures</span></div>' +
            '<span class="vglow-countdown-sep">:</span>' +
            '<div class="vglow-countdown-block"><span class="vglow-countdown-num" id="vglow-cd-m">00</span><span class="vglow-countdown-label">Minutes</span></div>' +
            '<span class="vglow-countdown-sep">:</span>' +
            '<div class="vglow-countdown-block"><span class="vglow-countdown-num" id="vglow-cd-s">00</span><span class="vglow-countdown-label">Secondes</span></div>' +
          '</div>' +
          '<p class="vglow-offer-urgency"> <strong> 20% </strong> OFF </p>' +
          '<button class="vglow-cta" id="vglow-add-cart"><span class="vglow-cta-text">' + COPY.routineCTA + '</span></button>' +
          '<p class="vglow-offer-footer">Your personalized matches are ready — complete your V-GLOW routine now.</p>' +
        '</div>';

  
root.querySelectorAll(".vglow-add-single").forEach(function (btn) {
  btn.addEventListener("click", function () {
    btn.disabled = true;
    btn.textContent = "Adding…";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
    }).then(function (r) {
      btn.textContent = r.ok ? "Added ✓" : "Error";
      btn.disabled = false;
    });
  });
});

      root.querySelector("#vglow-add-cart").addEventListener("click", function () {
        if (!addableIds.length) return;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: addableIds })
        }).then(function () { window.location.href = "/cart"; });
      });

      startCountdown();
    }

    renderQuestion();
  }

  window.VGlowQuiz = { init: initVGlowQuiz, computeVGlowResult: computeVGlowResult, CATALOG: CATALOG };
})();